import { Pipe, PipeTransform } from '@angular/core';

import { DashInsteadOfNullPipe } from './dash-instead-of-null.pipe';
import { NumberswitcherPipe } from "./numberswitcher.pipe";
import { NegativeValueToBracesPipe } from "./negative-value-to-braces.pipe";

@Pipe({
  name: 'switcherDashBraces',
})
/**
 * Transforms the input value first by applying a number switch based on the provided switcher and numbs parameters,
 * then formats negative numbers with braces and replaces null or undefined values with a dash.
 * Optionally, a prefix and/or suffix can be added around the final value.
 * Optionally, if you don't want to show '-' instead of zero or null/undefined value, you can set showEmpty to true
 *
 * Example of usage:
 * ```
 *  <td>{{ round.multiple | switcherDashBraces:1:2:false:'x' }}</td>
 *  ```
 *  before: -32.49923, after: (x32.50)
 */
export class SwitcherDashBracesPipe implements PipeTransform {
  transform(value: number | string, switcher: number, numbs: number, showEmpty?: boolean, prefix?: string, suffix?: string): string {
    const numberSwitchedValue = new NumberswitcherPipe().transform(value, switcher, numbs);

    if (showEmpty && (!numberSwitchedValue || numberSwitchedValue === '-')) {
      return '';
    }

    const bracedValue = new NegativeValueToBracesPipe().transform(numberSwitchedValue);
    const finalValue = new DashInsteadOfNullPipe().transform(bracedValue);

    // add prefix and suffix if finalValue is not '-' and prefix or suffix are provided
    if (finalValue !== '-' && (prefix || suffix)) {
      return this.applyPrefixSuffix(finalValue, prefix, suffix);
    }

    return finalValue;
  }

  private applyPrefixSuffix(value: string, prefix?: string, suffix?: string): string {
    // If value starts with '(', insert prefix after '(' and suffix before ')'
    if (value.startsWith('(')) {
      return `(${prefix || ''}${value.substring(1, value.length - 1)}${suffix || ''})`;
    }
    // Apply prefix and suffix normally
    return `${prefix || ''}${value}${suffix || ''}`;
  }
}
